import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class FullScreen extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        fullScreen: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.updateSettings = this.updateSettings.bind(this);
    }

    componentWillMount() {
        const {changeDeviceSettings} = this.props;
        if (typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.get === 'function') {
            changeDeviceSettings('fullScreen', window.parent.Ocellot.get('fullscreen', true));
        }
    }

    updateSettings(fullScreen) {
        const {changeDeviceSettings} = this.props;

        changeDeviceSettings('fullScreen', fullScreen);
        if (typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.setFullscreen === 'function') {
            window.parent.Ocellot.setFullscreen(fullScreen);
        }
    }

    render() {
        const {fullScreen, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-left text-black">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span>{msg.settings.fullscreen.title}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                <div className="switch">
                        <div className={`switch-option text-l ${!!fullScreen ? 'active' : ''} color-greenLight`}
                             onClick={() => this.updateSettings(true)}>
                            <div className="switch-inner">
                                <span>{msg.settings.on}</span>
                            </div>
                        </div>
                        <div className={`switch-option text-l ${!!fullScreen ? '' : 'active'} color-red`}
                             onClick={() => this.updateSettings(false)}>
                            <div className="switch-inner">
                                <span>{msg.settings.off}</span>
                            </div>
                        </div>
                </div>
              </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    fullScreen: state.device.fullScreen
}), {changeDeviceSettings})(FullScreen);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/FullScreen.js